import React from 'react';

import LanguageSelector from '../components/language-selector';
import { ConfirmOtp } from '../confirm-otp';
import SignIn from '../sign-in';

import { SignUpPanel } from './sign-up-home.styled';
import { AuthenticationTabProps } from './types';

const SigninTab = React.memo(({ showOtpForm, extraFields }: AuthenticationTabProps) => {
  return (
    <SignUpPanel>
      {showOtpForm ? <ConfirmOtp /> : <SignIn authCampaignExtraFields={extraFields} />}
      <LanguageSelector />
    </SignUpPanel>
  );
});

export default SigninTab;
